import React from "react"

export const AlleLeistungsarten = (props) => {
  return (
    <svg
      width={88}
      height={92}
      viewBox="0 0 88 92"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M24 56.455l10.951-3.105a19.766 19.766 0 0115.657 2.127v0a.395.395 0 00.205.057H64V63H52.865"
        stroke="#034055"
        strokeWidth={3}
      />
      <path
        d="M34 77h26.859c3.294 0 6.53-.878 9.372-2.544v0a18.54 18.54 0 004.758-3.994L86 57.5 81.186 51l-6.832 6.158a27.556 27.556 0 01-10.63 5.956v0"
        stroke="#034055"
        strokeWidth={3}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.905 54.203l15.141 26.203-1.343 5.01-6.358 3.668-18.813-32.556 6.358-3.668 5.015 1.343z"
        fill="#B3CBD4"
        stroke="#B3CBD4"
        strokeWidth={3}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.33 51.66l16.44 28.449-1.458 5.44-6.903 3.981L.984 54.184l6.903-3.982 5.444 1.457z"
        fill="#FFD62E"
      />
      <circle cx={59.5} cy={25.5} r={14.5} fill="#F0C202" stroke="#F0C202" />
      <path
        clipRule="evenodd"
        d="M67.168 2.656l14.443 14.43-14.443 14.43-14.443-14.43 14.443-14.43z"
        stroke="#034055"
        strokeWidth={3}
      />
    </svg>
  )
}
